export const MAX_PROMOS_PER_SCREEN = 3;
